import React, {useState} from 'react'
import moment from 'moment';

import Page from "../../component/Page/Page";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import {StockLevelHeader} from "./StockLevelHeader";
import {StockLevelByProductTypeTable} from "./StockLevelByProductTypeTable";
import {todayFirstTime, todayLastTime} from "../../utils/dates";

export const StockLevelGridPage = () => {

  const [startDate, setStartDate] = useState(todayLastTime())
  const [endDate, setEndDate] = useState(moment().subtract(6, 'days').toDate());
  const [bizLocation, setBizLocation] = useState(null);

  return (
      <Page
          breadcrumbs={[<BreadcrumbItem key={1} title="Evolução"/>]}
          title="Evolução do Parque"
      >
        <StockLevelHeader
          setBizLocation={(bizLocation) => setBizLocation(bizLocation)}
          defaultEndDate={endDate}
          defaultStartDate={startDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      <StockLevelByProductTypeTable startDate={startDate} endDate={endDate} bizLocation={bizLocation}/>
      </Page>
  )
}



// WEBPACK FOOTER //
// ./src/pages/StockLevel/StockLevelByProductTypePage.js